
import { Container } from "reactstrap"
import { useTranslation, withTranslation } from "react-i18next"
import Flag from "react-world-flags";
import { FaBookOpen, FaDna, FaEnvelope, FaFlask, FaLock } from "react-icons/fa";

const KitTechnologie = () => {
    const { t } = useTranslation()

    return (
        <div className="pb-5">
            <Container style={{ maxWidth: "900px" }}>
                {/* Section : Ce que contient le kit */}
                <h2 className="text-center mb-4 pb-2 dark-blue">{t("kitsTechno|Ce que contient le kit")}</h2>
                <div className="mobile-text">
                    <ul className="kit-list">
                        <li><FaFlask className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("kitsTechno|Tube sécurisé avec stabilisateur ADN")}</li>
                        <li><FaBookOpen className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("kitsTechno|Notice illustrée")}</li>
                        <li><FaEnvelope className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("kitsTechno|Enveloppe de retour prépayée")}</li>
                        <li><FaLock className="icon-fix-small mr-1 dark-blue fix-icon-pad" /> {t("kitsTechno|Accès à votre espace de résultats personnalisé")}</li>
                        <li><Flag code="FR" alt="FR" className="icon-fix-small mr-2" />{t("kitsTechno|Fabriqué et analysé dans notre laboratoire à Rennes")}</li>
                    </ul>
                </div>
                    {/* Section : Technologie */}
                 <h2 className="text-center mt-5 mb-4 pb-0 pb-md-3 dark-blue">{t("kitsTechno|Une technologie de séquençage de pointe")}</h2>
                <div className="mobile-text">
                    <p className="text-center">
                        {t("kitsTechno|Le kit Nahibu utilise la méthode d’analyse métagénomique shotgun, la plus avancée à ce jour. Elle permet de séquencer l’ensemble des gènes de votre microbiote intestinal pour une lecture précise, riche et exploitable scientifiquement.")}
                    </p>
                    <p className="text-center font-weight-bold mt-4 " style={{ fontSize: "1.1rem" }}>
                        <FaDna className="icon-fix-small mr-1 dark-blue fix-icon-pad" />  {t("kitsTechno|Laboratoire n°1 en France pour l’analyse du microbiote intestinal.")}
                    </p>
                </div>
            </Container>
        </div>
    )
}

export default withTranslation()(KitTechnologie)
